<template>
  <div>
    <h4 class="mb-4">{{ componentData.compTitle }}</h4>
    <b-form-group
      class="component-field"
      description="How the widget's variable will be named."
    >
      <h6>Variable Name</h6>
      <b-form-input
        id="FileUploadVariableName"
        v-model="componentData.data.variableName"
        placeholder="Enter the variable name"
        :state="notEmpty(componentData.data.variableName)"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      class="component-field"
      v-for="(field, index) in componentData.fields"
      :description="field.description"
      :key="index"
    >
      <h6>{{ field.title }}</h6>

      <b-form-input
        v-if="field.type === 'input'"
        v-model="componentData.data[field.name]"
        :placeholder="'Enter the ' + field.name"
        :state="
          field.required ? notEmpty(componentData.data[field.name]) : null
        "
      ></b-form-input>

      <b-form-input
        v-if="field.type === 'number'"
        type="number"
        v-model="componentData.data[field.name]"
        :placeholder="'Enter the ' + field.name + ' number'"
        :state="
          field.required ? componentData.data[field.name] !== undefined : null
        "
      ></b-form-input>

      <b-form-tags
        v-if="field.type === 'tag'"
        v-model="componentData.data[field.name]"
        separator=" ,;"
        placeholder="Enter new tags separated by space, comma or semicolon"
        :state="
          field.required ? notEmpty(componentData.data[field.name]) : null
        "
        no-add-on-enter
        remove-on-delete
      ></b-form-tags>

      <b-form-checkbox
        v-if="field.type === 'checkbox'"
        v-model="componentData.data[field.name]"
        name="checkbox-1"
      ></b-form-checkbox>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "InputWidget",
  props: ["componentData"],
  // created() {
  //   console.log(this.componentData);
  // },
  methods: {
    notEmpty(value) {
      if (value === undefined) return false;

      if (value) return true;
      else return false;
    },
  },
  computed: {
    inputCompString() {
      let fullString = this.componentData.data.variableName + " = streamlit.";
      fullString += this.componentData.functionName + "(";

      for (let i = 0; i < this.componentData.fields.length; i++) {
        const field = this.componentData.fields[i];

        // Undefined data is skipped
        if (!this.componentData.data[field.name]) continue;

        switch (field.type) {
          case "input": {
            fullString +=
              field.name + "='" + this.componentData.data[field.name] + "', ";
            break;
          }
          case "number": {
            fullString +=
              field.name + "=" + this.componentData.data[field.name] + ", ";
            break;
          }
          case "tag": {
            fullString +=
              field.name +
              "=" +
              JSON.stringify(this.componentData.data[field.name]) +
              ", ";
            break;
          }
          case "checkbox": {
            fullString += field.name + "=";
            fullString +=
              this.componentData.data[field.name] === true ? "True" : "False";
            fullString += ", ";
            break;
          }
          default: {
            break;
          }
        }
      }

      fullString += ")";

      return fullString;
    },
    isValid() {
      for (let i = 0; i < this.componentData.fields.length; i++) {
        const field = this.componentData.fields[i];
        if (
          field.required &&
          !this.notEmpty(this.componentData.data[field.name])
        ) {
          return false;
        }
      }

      return true;
    },
  },
  watch: {
    inputCompString(newValue) {
      this.$emit("update-input-creation-string", {
        id: this.componentData.id,
        newValue,
      });
    },

    isValid(newValue) {
      this.$emit("update-input-state", { id: this.componentData.id, newValue });
    },
  },
};
</script>

<style scoped lang="scss"></style>
